import state from './moduleContractState'
import actions from './moduleContractActions'
import getters from './moduleContractGetters'
import mutations from './moduleContractMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
